const VALIDATIONS = {
    'accepted': '',
    'active_url': '',
    'after': '', // :date
    'after_or_equal': '', // :date
    'alpha': 'alpha',
    'alpha_dash': '',
    'alpha_num': 'alphaNum',
    'array': '',
    'before': '', // :date
    'before_or_equal': '', // :date
    'between': '', // :min,max
    'boolean': '',
    'confirmed': '',
    'date': 'date',
    'date_equals': '', // :date
    'date_format': '', // :format
    'different': '', // :field
    'digits': 'digits', // :value
    'digits_between': '', // :min,max
    'dimensions': '',
    'distinct': '',
    'email': 'email',
    'exists': '', // :table,column
    'file': '',
    'filled': '',
    'image': '',
    'in': '', // :foo,bar,...
    'in_array': '', // :anotherfield
    'integer': '',
    'ip': '',
    'ipv4': '',
    'ipv6': '',
    'json': '',
    'max': 'maxLength',
    'mimetypes': '', // :text/plain,...
    'mimes': '', // :foo,bar,...
    'min': 'minLength',
    'nullable': '',
    'not_in': '', // :foo,bar,...
    'numeric': '',
    'present': '',
    'regex': '', // :pattern
    'required': 'required',
    'required_if': '', // :anotherfield,value,...
    'required_unless': '', // :anotherfield,value,...
    'required_with': '', // :foo,bar,...
    'required_with_all': '', // :foo,bar,...
    'required_without': '', // :foo,bar,...
    'required_without_all': '', // :foo,bar,...
    'same': '', // :field
    'size': 'count', // :value
    'string': '',
    'timezone': '',
    'unique': '', // :table
};

export class ExtraFieldValidationRuleService {
    /**
     * Return a valid validation rule for the ValidationManager
     * */
    public static getValidationRuleName(rule: string): string {
        if (VALIDATIONS.hasOwnProperty(rule)) {
            return VALIDATIONS[rule];
        }

        return '';
    }
}


// WEBPACK FOOTER //
// /codebuild/output/src3894461559/src/src/app/shared/services/extra-field-validation-rule.service.ts